import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import axios from "../../context/AxiosInstance";
import Swal from "sweetalert2";

const UtilisateurFormModal = ({
  show,
  handleClose,
  isEditMode,
  selectedUser,
  token,
  refreshData,
}) => {
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    login: "",
    mot_de_passe: "",
    telephone: "",
    type_compte: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const typeOptions = ["ADMIN", "RH", "ASSISTANT", "PERSONNEL"]; 

  useEffect(() => {
    if (isEditMode && selectedUser) {
      setFormData({
        nom: selectedUser.nom || "",
        prenom: selectedUser.prenom || "",
        login: selectedUser.login || "",
        mot_de_passe: "",
        telephone: selectedUser.telephone || "",
        type_compte: (selectedUser.type_compte || "").toUpperCase(),
      });
    } else {
      setFormData({
        nom: "",
        prenom: "",
        login: "",
        mot_de_passe: "",
        telephone: "",
        type_compte: "",
      });
    }
    setErrors({});
  }, [show, isEditMode, selectedUser]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.nom) newErrors.nom = "Champ requis";
    if (!formData.prenom) newErrors.prenom = "Champ requis";
    if (!formData.login) newErrors.login = "Champ requis";
    if (!isEditMode && !formData.mot_de_passe) newErrors.mot_de_passe = "Champ requis";
    if (!formData.type_compte) newErrors.type_compte = "Champ requis";
    if (!formData.telephone) newErrors.telephone = "Champ requis";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const valErrors = validate();
    if (Object.keys(valErrors).length > 0) {
      setErrors(valErrors);
      return;
    }

    setLoading(true);
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      if (isEditMode) {
        // Si l'utilisateur est PERSONNEL: seule la modification du statut est autorisée
        const payload = (formData.type_compte === "PERSONNEL")
          ? { is_active: selectedUser.is_active }
          : formData;
        await axios.patch(`/utilisateurs/${selectedUser.id_user}`, payload, config);
        Swal.fire("✅ Modifié", "", "success");
      } else {
        await axios.post("/utilisateurs/", formData, config);
        Swal.fire("✅ Ajouté", "", "success");
      }

      refreshData();
      handleClose();
    } catch (err) {
      Swal.fire("Erreur", "Échec de l'enregistrement", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{isEditMode ? "✏ Modifier" : "➕ Ajouter"} un utilisateur</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {["nom", "prenom", "login", "telephone"].map((field) => (
            <Form.Group className="mb-3" key={field}>
              <Form.Label>{field.charAt(0).toUpperCase() + field.slice(1)}</Form.Label>
              <Form.Control
                name={field}
                value={formData[field]}
                onChange={handleChange}
                isInvalid={!!errors[field]}
                disabled={isEditMode && (selectedUser?.type_compte || "").toUpperCase() === "PERSONNEL" && field !== "telephone"}
              />
              <Form.Control.Feedback type="invalid">
                {errors[field]}
              </Form.Control.Feedback>
            </Form.Group>
          ))}

          {!isEditMode && (
            <Form.Group className="mb-3">
              <Form.Label>Mot de passe</Form.Label>
              <Form.Control
                type="password"
                name="mot_de_passe"
                value={formData.mot_de_passe}
                onChange={handleChange}
                isInvalid={!!errors.mot_de_passe}
              />
              <Form.Control.Feedback type="invalid">
                {errors.mot_de_passe}
              </Form.Control.Feedback>
            </Form.Group>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Type de compte</Form.Label>
            <Form.Select
              name="type_compte"
              value={formData.type_compte}
              onChange={handleChange}
              isInvalid={!!errors.type_compte}
              disabled={isEditMode && (selectedUser?.type_compte || "").toUpperCase() === "PERSONNEL"}
            >
              <option value="">-- Choisir un rôle --</option>
              {typeOptions.map((type) => (
                <option key={type} value={type}>{type}</option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.type_compte}
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Annuler</Button>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? <Spinner animation="border" size="sm" /> : isEditMode ? "Modifier" : "Ajouter"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UtilisateurFormModal;
